import { Card } from "primereact/card"
import { Link, useParams } from "react-router-dom"
import { useEffect, useRef, useState } from "react"
import { connect, useDispatch, useSelector } from "react-redux"
import { AppDispatch } from "../../../../store"
import { interviewListingForJob, matchJobToResumes, retrieveJob, updateResumeMatchingType } from "../JobAction"
import { Column } from "primereact/column"
import { DataTable, DataTableFilterMeta } from "primereact/datatable"
import LinkButton from "../../../../constants/helpers/LinkButton"
import { ProgressBar } from "primereact/progressbar"
import { Badge } from "primereact/badge"
import { Knob } from "primereact/knob"
import { Toast } from "primereact/toast"
import { FilterMatchMode } from "primereact/api"
import { Job, ResumeMatchingResult, ResumeMatchType } from "../interface"
import { Dropdown } from "primereact/dropdown"
import { SplitButton } from "primereact/splitbutton"
import { Toolbar } from "primereact/toolbar"
import { Button } from "primereact/button"
import { InterviewStatusEnum } from "../../../../CandidatePortal/scenes/Interview/Chatbot/interface"
import { Calendar } from "primereact/calendar"
import { Slider } from "primereact/slider"

interface InterviewListingProps {
}

const InterviewListing = (props: InterviewListingProps) => {
  const toast = useRef<any>(null)
  const dt = useRef<any>(null);
  const dispatch = useDispatch<AppDispatch>()

  const { jobId } = useParams<{ jobId: string }>()
  const { job, interviewList, totalRecords } = useSelector((state: any) => state.job)

  // loading matching
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    // load job from db
    if (jobId) {
      dispatch(retrieveJob(Number(jobId)))
    }
  }, [])

  // datatable states
  let filters: DataTableFilterMeta = {
    fullName: { value: null, matchMode: FilterMatchMode.EQUALS },
    matchingPercentage: { value: null, matchMode: FilterMatchMode.EQUALS },
    description: { value: null, matchMode: FilterMatchMode.EQUALS },
    type: { value: null, matchMode: FilterMatchMode.EQUALS },
    status: { value: null, matchMode: FilterMatchMode.EQUALS },
  }
  const [rows, setRows] = useState(5)

  // Custom Filter Details
  const [selectedStatus, setSelectedStatus] = useState(undefined)
  const [selectedPercentage, setSelectedPercentage] = useState<[number, number]>([0, 100])
  const [selectedStartDate, setSelectedStartDate] = useState(undefined)
  const [selectedEndDate, setSelectedEndDate] = useState(undefined)

  const [lazyParams, setLazyParams] = useState({
    first: 0,
    rows: rows,
    page: 0,
    sortField: "interviewResult.totalScorePercentage",
    sortOrder: -1,
    filters
  })

  const init = () => {
    dispatch(interviewListingForJob({jobId: Number(jobId), lazyParams}))
      .finally(() => {
        setLoading(false)
      })
  }

  //Lazy loading
  useEffect(() => {
    init()
  }, [lazyParams])

  const onPage = (event: any) => {
    setRows(event.rows)
    let _lazyParams = { ...lazyParams, ...event }
    setLazyParams(_lazyParams)
  }

  const onSort = (event: any) => {
    let _lazyParams = { ...lazyParams, ...event }
    setLazyParams(_lazyParams)
  }

  const onFilter = (event: any) => {
    let _lazyParams = { ...lazyParams, ...event }
    _lazyParams['first'] = 0;
    setLazyParams(_lazyParams)
  }

  const onPercentageChange = (e: any) => {
    setSelectedPercentage(e.value)
    if (e.value && e.value[0] != null && e.value[1] != null) {
      let _lazyParams = { ...lazyParams }
      _lazyParams.filters.totalScorePercentageLt = { value: e.value[0], matchMode: FilterMatchMode.EQUALS  }
      _lazyParams.filters.totalScorePercentageGt = { value: e.value[1], matchMode: FilterMatchMode.EQUALS }
      setLazyParams(_lazyParams)
    } else {
      let _lazyParams = { ...lazyParams }
      setLazyParams(_lazyParams)
    }
  }

  const onStartDateChange = (e: any) => {
    setSelectedStartDate(e.value)
    if (e.value) {
      let startDate = `${e.value.getFullYear()}-${e.value.getMonth() + 1}-${e.value.getDate()}`
      let endDate = `${e.value.getFullYear()}-${e.value.getMonth() + 1}-${e.value.getDate() + 1}`
      let _lazyParams = { ...lazyParams }
      _lazyParams.filters.startDateTimeLt = { value: startDate, matchMode: FilterMatchMode.EQUALS  }
      _lazyParams.filters.startDateTimeGt = { value: endDate, matchMode: FilterMatchMode.EQUALS  }
      setLazyParams(_lazyParams)
    } else {
      let _lazyParams = { ...lazyParams }
      setLazyParams(_lazyParams)
    }
  }

  const onEndDateChange = (e: any) => {
    setSelectedEndDate(e.value)
    if (e.value) {
      let startDate = `${e.value.getFullYear()}-${e.value.getMonth() + 1}-${e.value.getDate()}`
      let endDate = `${e.value.getFullYear()}-${e.value.getMonth() + 1}-${e.value.getDate() + 1}`
      let _lazyParams = { ...lazyParams }
      _lazyParams.filters.endDateTimeLt = { value: startDate, matchMode: FilterMatchMode.EQUALS  }
      _lazyParams.filters.endDateTimeGt = { value: endDate, matchMode: FilterMatchMode.EQUALS  }
      setLazyParams(_lazyParams)
    } else {
      let _lazyParams = { ...lazyParams }
      setLazyParams(_lazyParams)
    }
  }
  
  const onStatusChange = (e: any) => {
    let _lazyParams = { ...lazyParams }
    _lazyParams.filters.status = { value: e.value, matchMode: FilterMatchMode.EQUALS }
    setLazyParams(_lazyParams)
    setSelectedStatus(e.value)
  }
  
  const handleResetFilters = () => {
    setSelectedStatus(undefined)

    dt.current.reset();
    let _lazyParams = { ...lazyParams }
    _lazyParams.filters = {}
    setLazyParams(_lazyParams)
  }

  const statuses = Object.keys(InterviewStatusEnum).filter(k => isNaN(Number(k)))
  const statusFilter = <Dropdown value={selectedStatus} options={statuses} onChange={onStatusChange} placeholder="All" className="p-column-filter" showClear></Dropdown>
  const dateFilter = <>
    <div className="w-100 flex justify-content-between align-items-center">
      <span>{selectedPercentage[0]}</span>
      <Slider
        value={selectedPercentage}
        onChange={(e) => {
          if (Array.isArray(e.value)) {
            setSelectedPercentage([e.value[0] || 0, e.value[1] || 100]);
          }
        }}
        onSlideEnd={onPercentageChange}
        className="w-5rem mx-3" range />
      <span>{selectedPercentage[1]}</span>
    </div>
  </>
  
  //<Calendar value={selectedCreateDate} showButtonBar readOnlyInput selectionMode="range" onChange={onCreatedDateChange} dateFormat="yy-mm-dd" className="p-column-filter" placeholder="YYYY-MM-DD"></Calendar>
  const startDateFilter = <Calendar value={selectedStartDate} showButtonBar maxDate={selectedEndDate} readOnlyInput selectionMode="single" onChange={onStartDateChange} dateFormat="yy-mm-dd" className="p-column-filter" placeholder="YYYY-MM-DD"></Calendar>
  const endDateFilter = <Calendar value={selectedEndDate} showButtonBar minDate={selectedStartDate} readOnlyInput selectionMode="single" onChange={onEndDateChange} dateFormat="yy-mm-dd" className="p-column-filter" placeholder="YYYY-MM-DD"></Calendar>
  
  const toolbar = () => {
    return (
      <>
        <Button type="button" label="Clear" className="p-button-outlined mr-2" icon="pi pi-filter-slash" onClick={handleResetFilters} />
      </>
    )
  }

  const getStatusStyling = (rowData: any) => {
    switch (rowData.status) {
      case InterviewStatusEnum.ACTIVE:
        return <Badge value={rowData.status} severity="info"></Badge>
      case InterviewStatusEnum.COMPLETED:
        return <Badge value={rowData.status} severity="success"></Badge>
      case InterviewStatusEnum.EXPIRED:
        return <Badge value={rowData.status} severity="danger"></Badge>
      case InterviewStatusEnum.INACTIVE:
        return <Badge value={rowData.status} severity="warning"></Badge>
    }
  }

  const percentageBodyTemplate = (rowData: any) => {
    return `${rowData.interviewResult.totalScorePercentage}%`
  }

  const startDateBodyTemplate = (rowData: any) => {
    let date = new Date(rowData.startDateTime)
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
  }

  const endDateBodyTemplate = (rowData: any) => {
    let date = new Date(rowData.endDateTime)
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`
  }

  const viewAndConfigureInterviewTemplate = (rowData: any) => {
    return (
      <div>
        <LinkButton to={`/interviews/${rowData.id}`} icon="pi pi-eye" iconOnly={true} tooltip="View details for this interview." tooltipOptions={{position: 'left'}} className="p-button-secondary"></LinkButton>
      </div>
    )
  }

  return (
    <>
      <Toast ref={toast} />
      <div>
        <Toolbar className="p-mb-4" start={toolbar}></Toolbar>
        <DataTable ref={dt} value={interviewList} first={lazyParams.first} rows={rows} totalRecords={totalRecords} loading={interviewList === undefined}
          onPage={onPage} onSort={onSort} sortField={lazyParams.sortField} sortOrder={lazyParams.sortOrder as any}
          onFilter={onFilter} filters={lazyParams.filters} filterDisplay="row"
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown" rowsPerPageOptions={[5, 10, 25]}
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          lazy paginator>
          <Column field="intervieweeName" header="Full Name" filter sortable></Column>
          <Column field="startDateTime" header="Start Date" body={startDateBodyTemplate} filter sortable filterElement={startDateFilter}></Column>
          <Column field="endDateTime" header="End Date" body={endDateBodyTemplate} filter sortable filterElement={endDateFilter}></Column>
          <Column field="status" header="Status" body={getStatusStyling} filter filterElement={statusFilter} sortable></Column>
          <Column field="interviewResult.totalScorePercentage" header="Total Score Percentage" body={percentageBodyTemplate} filter filterElement={dateFilter} sortable></Column>
          <Column body={viewAndConfigureInterviewTemplate} headerStyle={{ width: '6em', textAlign: 'center' }} bodyStyle={{ textAlign: 'center', overflow: 'visible' }} />
        </DataTable>
      </div>
    </>
  )
}

export default InterviewListing